import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-lesson-three-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFiveLessonThreeGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 5, Lesson 3 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 3: Independent Living Goals";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
